import { IconFont, SvgIcon, Warning } from '@/components'
import {
  Breadcrumb,
  Button,
  Cascader,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Tooltip,
  Typography,
} from 'antd'
import styled from 'styled-components'
import { t } from '@/i18n'
import { DownloadKey, OperateSystem } from './package'
import { useEffect, useState } from 'react'
import {
  useGetAgentKey,
  useGetIp,
  useGetpackagelist,
  useResetAgentKey,
  useGetAgentHostAndPort,
} from '../util'
import { useCommandGenerator } from './commandGenerator'
import BasSwitch from '@/pages/safety-equipment/widgets/bas-switch'
const { useForm } = Form

export const ClientDownload = () => {
  //获取ip地址
  const [getIp] = useGetIp()
  const [createForm] = useForm()
  const [getAgentHostAndPort, agentHostAndPort] = useGetAgentHostAndPort()
  //windows、linux、uos切换
  const [switchChange, setSwitchChange] = useState('windows') // windows、linux、uos切换
  const [connectType, setConnectType] = useState(1) // 1 直连、2代理
  //window安装方式改变
  const [installStyle, setInstallStyle] = useState<string>('1')
  //linux安装方式改变
  const [installStyle1, setInstallStyle1] = useState<string>('1')
  const [install, setIntasll] = useState<any>()
  const [installDatas, setIntasllData] = useState<any>()
  //windows系统版本
  const [versionChange, setVersionChange] = useState<string>()
  //linux系统版本
  const [versionChange1, setVersionChange1] = useState<string>()
  const [selectArch, setSelectArch] = useState<string>('X86')
  const [autoInstallDependencyEnv, setAutoInstallDependencyEnv] = useState<boolean>(false)
  const [enableDnatConfig, setEnableDnatConfig] = useState<boolean>(false)
  //获取子组件传递出来的值
  const installation = val => {
    setIntasll(val)
  }
  const installData = val => {
    setIntasllData(val)
  }
  useEffect(() => {
    getIp().catch(_ => {})
    getAgentHostAndPort().catch(_ => {})
    setInstallStyle('1')
    setInstallStyle1('1')
  }, [])
  //参数生成
  const [params, setParams] = useState<string>()

  // 使用命令生成器hook
  const { generateCommand } = useCommandGenerator({
    switchChange,
    installStyle,
    installStyle1,
    versionChange1: versionChange1 || '',
    selectArch,
    autoInstallDependencyEnv,
    installData: installDatas,
    enableDnatConfig,
    agentHostAndPort,
    onCommandGenerated: setParams,
  })

  const onFinish = async values => {
    if (!angentKey?.server_domain || !angentKey.token) {
      return
    }

    await generateCommand(values)
  }

  useEffect(() => {
    if (switchChange === 'uos') {
      createForm.setFieldsValue({ disposition: t('直连'), installStyle: '1' })
    }
  }, [switchChange])
  useEffect(() => {
    if (installStyle === '1' && installStyle1 === '1' && connectType === 1) {
      createForm.submit()
    }
  }, [installStyle, installStyle1, switchChange, connectType, install, installDatas])
  useEffect(() => {
    createForm.submit()
  }, [autoInstallDependencyEnv])

  // 当包信息变化时，重新生成命令
  useEffect(() => {
    if (installDatas && angentKey?.server_domain && angentKey.token) {
      createForm.submit()
    }
  }, [installDatas])

  // 当启用DNAT配置且接口数据加载完成时，填充平台端口和平台地址的默认值
  useEffect(() => {
    if (enableDnatConfig && agentHostAndPort) {
      const formValues: any = {}

      // 填充平台地址（优先使用 destination_host，如果没有则使用 destination_domain）
      if (agentHostAndPort.destination_host) {
        formValues.submit_destination_host = agentHostAndPort.destination_host
      } else if (agentHostAndPort.destination_domain) {
        formValues.submit_destination_host = agentHostAndPort.destination_domain
      }

      // 填充平台端口
      if (agentHostAndPort.saas_destination_port) {
        formValues.saas_destination_port = agentHostAndPort.saas_destination_port
      }
      if (agentHostAndPort.data_protect_http_destination_port) {
        formValues.data_protect_http_destination_port =
          agentHostAndPort.data_protect_http_destination_port
      }
      if (agentHostAndPort.data_protect_https_destination_port) {
        formValues.data_protect_https_destination_port =
          agentHostAndPort.data_protect_https_destination_port
      }
      if (agentHostAndPort.data_protect_git_destination_port) {
        formValues.data_protect_git_destination_port =
          agentHostAndPort.data_protect_git_destination_port
      }

      // 只在有值时才设置表单值
      if (Object.keys(formValues).length > 0) {
        createForm.setFieldsValue(formValues)
      }
    }
  }, [enableDnatConfig, agentHostAndPort])

  //windows代理可见
  const [agentVisible, setAgentVisible] = useState(false)
  //linux代理可见
  const [agentVisible1, setAgentVisible1] = useState(false)

  //密钥弹窗
  const [keyVisible, setKeyVisible] = useState(false)

  //生成密钥
  const [resetAngentKey, resetAngentKeyLoading] = useResetAgentKey()

  const [angentKey, getAngentKey] = useGetAgentKey()

  useEffect(() => {
    if (!agentVisible) {
      createForm.resetFields()
    }
  }, [agentVisible])

  //获取安装包列表
  const [getpackagelist] = useGetpackagelist()
  interface PackageData {
    file_size: string
    id: string
    name: string
    os: string
    os_version: string
    version: string
    os_architecture?: string
  }
  //存储安装包数据
  const [packageData, setPackageData] = useState<PackageData[]>([])

  //获取列表数据
  useEffect(() => {
    getpackagelist({})
      .then(res => {
        setPackageData(res.data.package || [])
        setSelectArch(
          res.data.package?.filter(i => i.os.indexOf('Linux') > -1 && i.os_architecture === 'X86')
            .length > 0
            ? 'X86'
            : 'ARM',
        )
        createForm.submit()
      })
      .catch(_ => {})
  }, [])

  return (
    <Page>
      <Breadcrumb style={{ paddingBottom: '12px' }}>
        <Breadcrumb.Item>{t('配置中心')}</Breadcrumb.Item>
        <Breadcrumb.Item>{t('客户端下载')}</Breadcrumb.Item>
      </Breadcrumb>
      <PageContain>
        <Left>
          <div
            className={switchChange === 'windows' ? 'img' : 'img_grey'}
            onClick={() => {
              setSwitchChange('windows')
              setParams('')
              setAgentVisible(false)
              setConnectType(1)
              setEnableDnatConfig(false)
              createForm.setFieldsValue({
                disposition: t('直连'),
                installStyle: '1',
                version: undefined,
                framework: undefined,
                enableDnatConfig: false,
                externalAddress: undefined,
                platformAddress: undefined,
                webServiceExternalPort: undefined,
                webServicePlatformPort: undefined,
                agentExternalPort: undefined,
                agentPlatformPort: undefined,
                dlpHttpExternalPort: undefined,
                dlpHttpPlatformPort: undefined,
                dlpHttpsExternalPort: undefined,
                dlpHttpsPlatformPort: undefined,
                dlpGitExternalPort: undefined,
                dlpGitPlatformPort: undefined,
              })
            }}
          >
            <SvgIcon
              name={switchChange === 'windows' ? 'Windows' : 'Windows_grey'}
              className="svg"
            />
            <div className="word">Windows</div>
          </div>

          <div
            className={switchChange === 'linux' ? 'img' : 'img_grey'}
            onClick={() => {
              setSwitchChange('linux')
              setParams('')
              setAgentVisible1(false)
              setConnectType(1)
              setEnableDnatConfig(false)
              createForm.setFieldsValue({
                disposition1: t('直连'),
                installStyle1: '1',
                version1: undefined,
                framework: undefined,
                enableDnatConfig: false,
                externalAddress: undefined,
                platformAddress: undefined,
                webServiceExternalPort: undefined,
                webServicePlatformPort: undefined,
                dlpHttpExternalPort: undefined,
                dlpHttpPlatformPort: undefined,
                dlpHttpsExternalPort: undefined,
                dlpHttpsPlatformPort: undefined,
                dlpGitExternalPort: undefined,
                dlpGitPlatformPort: undefined,
              })
            }}
          >
            <SvgIcon name={switchChange === 'linux' ? 'linux_ori' : 'linux_grey'} className="svg" />
            <div className="word">Linux</div>
          </div>
        </Left>

        <Middle>
          <div style={{ float: 'right', margin: '20px 15px 0 0' }}>
            <Button
              type="primary"
              onClick={() => {
                setKeyVisible(true)
              }}
            >
              {t('客户端密钥')}
            </Button>
          </div>
          <Form
            name="form"
            form={createForm}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            initialValues={{
              remember: true,
              autoInstallDependencyEnv: false,
              enableDnatConfig: false,
            }}
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
            style={{ marginTop: '50px' }}
          >
            {switchChange === 'windows' || switchChange === 'uos' ? (
              <>
                <FormItem>
                  <div className="title">
                    <SvgIcon
                      name={'install'}
                      style={{ width: '80px', height: '90px', margin: '0 0 -28px -25px' }}
                    />
                    <span className="formWord" style={{ margin: '16px 0 0 -20px' }}>
                      {t('选择安装方式')}
                    </span>
                  </div>
                  <div className="content">
                    <div className="line" />
                    <div className="itemForm">
                      <Form.Item label={t('安装方式')} name="install" initialValue={installStyle}>
                        <Select
                          style={{ width: '320px', height: '32px' }}
                          onChange={e => {
                            setInstallStyle(e)
                            setParams('')
                          }}
                        >
                          <Select.Option value="1">{t('安装包安装')}</Select.Option>
                          <Select.Option value="2">{t('一键命令安装')}</Select.Option>
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </FormItem>
                <FormItem>
                  <div className="title">
                    <SvgIcon
                      name={'disposition'}
                      style={{ width: '80px', height: '90px', margin: '-20px 0 -26px -25px' }}
                    />
                    <span className="formWord" style={{ marginLeft: '-20px' }}>
                      {t('配置信息') +
                        (switchChange === 'windows' && installStyle === '2'
                          ? t('（ARM架构环境可直接使用X86架构环境安装命令安装）')
                          : '')}
                    </span>
                  </div>
                  <div className="content">
                    <div className="line" />
                    <div className="itemForm">
                      {installStyle === '2' && (
                        <>
                          <Form.Item
                            label={t('系统架构')}
                            name="framework"
                            style={{ marginBottom: '20px' }}
                            initialValue={
                              packageData?.filter(
                                i =>
                                  i.os.includes(switchChange === 'windows' ? 'Windows' : 'UOS') &&
                                  i.os_architecture === 'X86',
                              ).length > 0
                                ? 'X86'
                                : 'ARM'
                            }
                            rules={[{ required: true, message: t('请选择系统架构') }]}
                          >
                            <Select
                              style={{ width: '320px', height: '32px' }}
                              placeholder={t('请选择系统架构')}
                              onChange={() => {
                                setParams('')
                              }}
                              options={packageData
                                ?.filter(i =>
                                  i.os.includes(switchChange === 'windows' ? 'Windows' : 'UOS'),
                                )
                                ?.map(item => ({
                                  value: item.os_architecture,
                                  label: item.os_architecture,
                                }))}
                            />
                          </Form.Item>
                          {switchChange === 'windows' ? (
                            <Form.Item
                              label={t('系统版本')}
                              name="version"
                              style={{ marginBottom: '20px' }}
                              rules={[{ required: true, message: t('请选择系统版本') }]}
                              initialValue={versionChange}
                            >
                              <Cascader
                                options={packageData
                                  ?.filter(i => i.os.includes('Windows'))
                                  ?.map(item => ({
                                    value: item.os,
                                    label: item.os,
                                    children: item.os_version?.split(',')?.map(i => ({
                                      value: i.includes('Windows') ? i : `Windows${i}`,
                                      label: i.includes('Windows') ? i : `Windows${i}`,
                                    })),
                                  }))}
                                onChange={e => {
                                  setVersionChange(e as unknown as string)
                                  setParams('')
                                }}
                                placeholder={t('请选择系统版本')}
                                style={{ width: '320px' }}
                              />
                            </Form.Item>
                          ) : (
                            <Form.Item
                              label={t('系统版本')}
                              name="version"
                              style={{ marginBottom: '20px' }}
                              rules={[{ required: true, message: t('请选择系统版本') }]}
                            >
                              <Select
                                style={{ width: '320px', height: '32px' }}
                                placeholder={t('请选择系统版本')}
                                onSelect={() => {}}
                                options={[
                                  ...new Set(
                                    packageData
                                      ?.filter(i => i.os.includes('UOS'))
                                      .flatMap(v => v.os_version.split(',')),
                                  ),
                                ]?.map(item => ({
                                  value: item,
                                  label: item,
                                }))}
                                onChange={e => {
                                  setVersionChange(e as unknown as string)
                                  setParams('')
                                }}
                              />
                            </Form.Item>
                          )}
                        </>
                      )}

                      <Form.Item
                        label={t('连接方式')}
                        name="disposition"
                        initialValue={t('直连')}
                        style={{ marginBottom: '20px' }}
                      >
                        <Select
                          style={{ width: '320px', height: '32px' }}
                          onSelect={e => {
                            setParams('')
                            if (e === t('代理')) {
                              setAgentVisible(true)
                              setConnectType(2)
                            } else {
                              setAgentVisible(false)
                              setConnectType(1)
                            }
                          }}
                        >
                          <Select.Option value={t('直连')}>{t('直连')}</Select.Option>
                          <Select.Option value={t('代理')}>{t('代理')}</Select.Option>
                        </Select>
                      </Form.Item>
                      {agentVisible && (
                        <>
                          <Form.Item
                            label={t('代理地址')}
                            name="address"
                            style={{ marginBottom: '20px' }}
                            rules={[
                              {
                                required: true,
                                message: t('请输入代理地址'),
                              },
                              {
                                pattern:
                                  /^(?:(?:[A-Za-z0-9](?:[A-Za-z0-9\-]{0,61}[A-Za-z0-9])?\.)+(?:[A-Za-z]{2,6}\.?|[A-Za-z0-9\-]{2,}\.?)|(?:\d{1,3}\.){3}\d{1,3}):(\d{1,5})$/,
                                message: t('输入格式错误'),
                              },
                            ]}
                          >
                            <Input
                              style={{ width: '320px', height: '32px' }}
                              placeholder={t('请输入域名：端口或IP：端口')}
                            />
                          </Form.Item>
                          <Form.Item
                            label={t('代理协议')}
                            name="agreement"
                            rules={[
                              {
                                required: true,
                                message: t('请选择代理协议'),
                              },
                            ]}
                          >
                            <Select
                              style={{ width: '320px', height: '32px' }}
                              onSelect={e => {
                                if (e === '2') setAgentVisible(true)
                              }}
                              placeholder={t('请选择代理协议')}
                            >
                              <Select.Option value="HTTPS">HTTPS</Select.Option>
                              <Select.Option value="HTTP">HTTP</Select.Option>
                              <Select.Option value="SOCKS5">SOCKS5</Select.Option>
                            </Select>
                          </Form.Item>
                          <Form.Item
                            label={t('代理用户名')}
                            name="username"
                            style={{ marginBottom: '20px', marginTop: '20px' }}
                          >
                            <Input
                              style={{ width: '320px', height: '32px' }}
                              placeholder={t('请输入代理用户名（可选）')}
                            />
                          </Form.Item>
                          <Form.Item
                            label={t('代理密码')}
                            name="password"
                            style={{ marginBottom: '20px' }}
                          >
                            <Input.Password
                              style={{ width: '320px', height: '32px' }}
                              placeholder={t('请输入代理密码（可选）')}
                            />
                          </Form.Item>
                        </>
                      )}
                      <Form.Item>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <span style={{ display: 'inline-block', marginRight: '20px' }}>
                            {t('自动安装验证环境')}
                          </span>
                          <Form.Item name="autoInstallDependencyEnv" valuePropName="checked">
                            <BasSwitch onChange={e => setAutoInstallDependencyEnv(e)} />
                          </Form.Item>
                          <Tooltip title={t('开启后会自动安装Nginx、Tomcat等依赖环境至本地')}>
                            <IconFont
                              type="icon-icon_help"
                              style={{
                                color: '#999',
                                marginLeft: 16,
                                fontSize: 16,
                                cursor: 'pointer',
                              }}
                            />
                          </Tooltip>
                        </div>
                      </Form.Item>
                      <Form.Item>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <span
                            style={{ display: 'inline-block', marginRight: '20px', width: '112px' }}
                          >
                            {t('启用DNAT配置')}
                          </span>
                          <Form.Item
                            name="enableDnatConfig"
                            valuePropName="checked"
                            initialValue={false}
                          >
                            <BasSwitch
                              onChange={e => {
                                setEnableDnatConfig(e)
                                if (!e) {
                                  createForm.setFieldsValue({
                                    externalAddress: undefined,
                                    platformAddress: undefined,
                                    webServiceExternalPort: undefined,
                                    webServicePlatformPort: undefined,
                                    agentExternalPort: undefined,
                                    agentPlatformPort: undefined,
                                    dlpHttpExternalPort: undefined,
                                    dlpHttpPlatformPort: undefined,
                                    dlpHttpsExternalPort: undefined,
                                    dlpHttpsPlatformPort: undefined,
                                    dlpGitExternalPort: undefined,
                                    dlpGitPlatformPort: undefined,
                                  })
                                }
                              }}
                            />
                          </Form.Item>
                          <Tooltip
                            title={t(
                              '若您的网络环境中,客户端无法直接访问BAS平台真实服务IP,可开启DNAT配置并填写地址映射关系,以确保客户端请求能正确转发到平台服务。',
                            )}
                          >
                            <IconFont
                              type="icon-icon_help"
                              style={{
                                color: '#999',
                                marginLeft: 16,
                                fontSize: 16,
                                cursor: 'pointer',
                              }}
                            />
                          </Tooltip>
                        </div>
                      </Form.Item>
                      {enableDnatConfig && (
                        <div className="dnat-container">
                          <div
                            className="box"
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              marginBottom: '20px',
                              gap: '16px',
                            }}
                          >
                            <div
                              style={{
                                fontWeight: 500,
                                color: '#333',
                                width: '186px',
                                flexShrink: 0,
                                lineHeight: '32px',
                              }}
                            >
                              {t('地址映射')}
                            </div>
                            <div
                              className="dnat-form-item"
                              style={{ display: 'flex', gap: '0px', flex: 1, minWidth: 0 }}
                            >
                              <Form.Item
                                label={t('外部地址')}
                                name="source_host"
                                style={{
                                  flex: 1,
                                  marginBottom: 0,
                                  minWidth: 0,
                                  marginRight: '10px',
                                }}
                                rules={[{ required: true, message: t('请填写用于映射的IP/域名') }]}
                              >
                                <Input
                                  style={{ width: '100%', height: '32px' }}
                                  placeholder={t('请填写用于映射的IP/域名')}
                                />
                              </Form.Item>
                              <Form.Item
                                label={t('平台地址')}
                                name="submit_destination_host"
                                className="destination_host"
                                style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                rules={[{ required: true, message: t('请填写平台IP/域名') }]}
                              >
                                <Input
                                  style={{ width: '100%', height: '32px' }}
                                  placeholder={t('请填写平台IP/域名')}
                                />
                              </Form.Item>
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              marginBottom: '20px',
                              gap: '16px',
                            }}
                          >
                            <div
                              style={{
                                fontWeight: 500,
                                color: '#333',
                                width: '60px',
                                flexShrink: 0,
                                lineHeight: '32px',
                              }}
                            >
                              {t('端口映射')}
                            </div>
                            <div style={{ flex: 1 }}>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  marginBottom: '20px',
                                  gap: '16px',
                                }}
                              >
                                <div
                                  style={{
                                    width: '120px',
                                    fontWeight: 500,
                                    color: '#666',
                                    fontSize: '14px',
                                    flexShrink: 0,
                                  }}
                                >
                                  {t('平台Web服务')}
                                </div>
                                <div style={{ display: 'flex', gap: '16px', flex: 1, minWidth: 0 }}>
                                  <Form.Item
                                    label={t('外部端口')}
                                    name="saas_source_port"
                                    style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                  >
                                    <InputNumber
                                      style={{ width: '100%' }}
                                      placeholder={t('请填写用于映射端口')}
                                      min={1}
                                      max={65535}
                                    />
                                  </Form.Item>
                                  <Form.Item
                                    label={t('平台端口')}
                                    name="saas_destination_port"
                                    style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                  >
                                    <InputNumber
                                      style={{ width: '100%' }}
                                      placeholder={t('请填写平台端口')}
                                      min={1}
                                      max={65535}
                                      disabled
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  marginBottom: '20px',
                                  gap: '16px',
                                }}
                              >
                                <div
                                  style={{
                                    width: '120px',
                                    fontWeight: 500,
                                    color: '#666',
                                    fontSize: '14px',
                                    flexShrink: 0,
                                  }}
                                >
                                  {t('数据防泄漏 (HTTP)')}
                                </div>
                                <div style={{ display: 'flex', gap: '16px', flex: 1, minWidth: 0 }}>
                                  <Form.Item
                                    label={t('外部端口')}
                                    name="data_protect_http_source_port"
                                    style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                  >
                                    <InputNumber
                                      style={{ width: '100%' }}
                                      placeholder={t('请填写用于映射端口')}
                                      min={1}
                                      max={65535}
                                    />
                                  </Form.Item>
                                  <Form.Item
                                    label={t('平台端口')}
                                    name="data_protect_http_destination_port"
                                    style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                  >
                                    <InputNumber
                                      style={{ width: '100%' }}
                                      placeholder={t('请填写平台端口')}
                                      min={1}
                                      max={65535}
                                      disabled
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  marginBottom: '20px',
                                  gap: '16px',
                                }}
                              >
                                <div
                                  style={{
                                    width: '120px',
                                    fontWeight: 500,
                                    color: '#666',
                                    fontSize: '14px',
                                    flexShrink: 0,
                                  }}
                                >
                                  {t('数据防泄漏 (HTTPS)')}
                                </div>
                                <div style={{ display: 'flex', gap: '16px', flex: 1, minWidth: 0 }}>
                                  <Form.Item
                                    label={t('外部端口')}
                                    name="data_protect_https_source_port"
                                    style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                  >
                                    <InputNumber
                                      style={{ width: '100%' }}
                                      placeholder={t('请填写用于映射端口')}
                                      min={1}
                                      max={65535}
                                    />
                                  </Form.Item>
                                  <Form.Item
                                    label={t('平台端口')}
                                    name="data_protect_https_destination_port"
                                    style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                  >
                                    <InputNumber
                                      style={{ width: '100%' }}
                                      placeholder={t('请填写平台端口')}
                                      min={1}
                                      max={65535}
                                      disabled
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  marginBottom: '20px',
                                  gap: '16px',
                                }}
                              >
                                <div
                                  style={{
                                    width: '120px',
                                    fontWeight: 500,
                                    color: '#666',
                                    fontSize: '14px',
                                    flexShrink: 0,
                                  }}
                                >
                                  {t('数据防泄漏 (GIT)')}
                                </div>
                                <div style={{ display: 'flex', gap: '16px', flex: 1, minWidth: 0 }}>
                                  <Form.Item
                                    label={t('外部端口')}
                                    name="data_protect_git_source_port"
                                    style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                  >
                                    <InputNumber
                                      style={{ width: '100%' }}
                                      placeholder={t('请填写用于映射端口')}
                                      min={1}
                                      max={65535}
                                    />
                                  </Form.Item>
                                  <Form.Item
                                    label={t('平台端口')}
                                    name="data_protect_git_destination_port"
                                    style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                  >
                                    <InputNumber
                                      style={{ width: '100%' }}
                                      placeholder={t('请填写平台端口')}
                                      min={1}
                                      max={65535}
                                      disabled
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </FormItem>

                {installStyle === '1' && (
                  <FormItem>
                    <div className="title">
                      <SvgIcon
                        name={'download'}
                        style={{ width: '80px', height: '90px', margin: '-20px 0 -22px -25px' }}
                      />
                      <span className="formWord" style={{ margin: '-6px 0 0 -20px' }}>
                        {t('下载安装包') +
                          (switchChange !== 'uos'
                            ? t('（ARM架构环境可直接使用X86架构环境安装包安装）')
                            : '')}
                      </span>
                    </div>
                    <div className="content">
                      <div className="line" />
                      <div className="itemForm" style={{ margin: '30px 0' }}>
                        <DownloadKey
                          switchChange={switchChange}
                          installation={installation}
                          installData={installData}
                        />
                      </div>
                    </div>
                  </FormItem>
                )}
                <FormItem style={{ width: '100%', marginBottom: '50px' }}>
                  <div className="title">
                    <SvgIcon
                      name={'generate'}
                      style={{ width: '80px', height: '90px', margin: '-20px 0 -22px -25px' }}
                    />

                    <span className="formWord" style={{ margin: '-6px 0 0 -20px' }}>
                      {installStyle === '1' && t('生成参数')}
                      {installStyle === '2' && t('生成命令')}
                    </span>
                  </div>
                  <div className="content">
                    <div className="line" style={{ border: ' 1px solid #fff' }} />
                    <div style={{ width: '100%' }}>
                      <Button
                        type="primary"
                        style={{ margin: '20px 15px 8px 0', float: 'right' }}
                        onClick={createForm.submit}
                      >
                        {installStyle === '1' && t('生成参数')}
                        {installStyle === '2' && t('生成命令')}
                      </Button>
                      {installStyle === '1' &&
                        (switchChange === 'windows' ? (
                          <span
                            style={{
                              marginTop: '37px',
                              display: 'inline-block',
                              fontSize: '12px',
                              fontWeight: '400',
                              color: '#999',
                            }}
                          >
                            {t('运行安装程序后，将生成的参数填入并点击安装即可')}
                          </span>
                        ) : (
                          <span
                            style={{
                              marginTop: '37px',
                              display: 'inline-block',
                              fontSize: '12px',
                              fontWeight: '400',
                              color: '#999',
                            }}
                          >
                            {t('下载安装包后，运行安装命令即可')}
                          </span>
                        ))}
                      {installStyle === '2' &&
                        (switchChange !== 'windows' ? (
                          <span
                            style={{
                              marginTop: '37px',
                              display: 'inline-block',
                              fontSize: '12px',
                              fontWeight: '400',
                              color: '#999',
                            }}
                          >
                            {t('请以root权限运行以下命令')}
                          </span>
                        ) : (
                          <span
                            style={{
                              marginTop: '37px',
                              display: 'inline-block',
                              fontSize: '12px',
                              fontWeight: '400',
                              color: '#999',
                            }}
                          >
                            {t('请在cmd中以管理员权限运行以下命令')}
                          </span>
                        ))}
                      <div
                        style={{
                          height: '100px',
                          marginRight: '15px',
                          background: '#F8F9FB',
                          borderRadius: ' 6px',
                          clear: 'both',
                          display: 'flex',
                          gap: '7px',
                          padding: '12px',
                          wordBreak: 'break-all',
                        }}
                      >
                        <Typography.Paragraph
                          copyable={{
                            icon: [
                              <IconFont style={{ color: '#999' }} key={1} type="icon-fuzhi" />,
                            ],
                            text: params,
                          }}
                        />
                        <span>{params}</span>
                      </div>
                    </div>
                  </div>
                </FormItem>
              </>
            ) : (
              <>
                <FormItem>
                  <div className="title">
                    <SvgIcon
                      name={'install'}
                      style={{ width: '80px', height: '90px', margin: '0 0 -28px -25px' }}
                    />
                    <span className="formWord" style={{ margin: '16px 0 0 -20px' }}>
                      {t('选择安装方式')}
                    </span>
                  </div>
                  <div className="content">
                    <div className="line" />
                    <div className="itemForm">
                      <Form.Item label={t('安装方式')} name="install1" initialValue={installStyle1}>
                        <Select
                          style={{ width: '320px', height: '32px' }}
                          onChange={e => {
                            setInstallStyle1(e)
                            setParams('')
                          }}
                        >
                          <Select.Option value="1">{t('安装包安装')}</Select.Option>
                          <Select.Option value="2">{t('一键命令安装')}</Select.Option>
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </FormItem>
                <FormItem>
                  <div className="title">
                    <SvgIcon
                      name={'disposition'}
                      style={{ width: '80px', height: '90px', margin: '-20px 0 -26px -25px' }}
                    />
                    <span className="formWord" style={{ marginLeft: '-20px' }}>
                      {t('配置信息') +
                        (installStyle1 === '2'
                          ? t('银河麒麟V10操作系统环境可直接使用X86架构Linux. rpm安装包安装')
                          : '')}
                    </span>
                  </div>
                  <div className="content">
                    <div className="line" />
                    <div className="itemForm">
                      {installStyle1 === '2' && (
                        <>
                          <Form.Item
                            label={t('系统架构')}
                            name="framework"
                            style={{ marginBottom: '20px' }}
                            initialValue={
                              packageData?.filter(
                                i => i.os.indexOf('Linux') > -1 && i.os_architecture === 'X86',
                              ).length > 0
                                ? 'X86'
                                : 'ARM'
                            }
                            rules={[{ required: true, message: t('请选择系统架构') }]}
                          >
                            <Select
                              style={{ width: '320px', height: '32px' }}
                              placeholder={t('请选择系统架构')}
                              onSelect={e => {
                                setParams('')
                                setSelectArch(e)
                              }}
                              options={Array.from(
                                new Set(
                                  packageData
                                    ?.filter(i => i.os.includes('Linux'))
                                    ?.map(item => item.os_architecture),
                                ),
                              ).map(item => ({ value: item, label: item }))}
                            />
                          </Form.Item>
                          <Form.Item
                            label={t('系统版本')}
                            name="version1"
                            style={{ marginBottom: '20px' }}
                            rules={[{ required: true, message: t('请选择系统版本') }]}
                            initialValue={versionChange1}
                          >
                            <Select
                              style={{ width: '320px', height: '32px' }}
                              onSelect={e => {
                                console.log('111')
                                setVersionChange1(e as string)
                                setParams('')
                              }}
                              placeholder={t('请选择系统版本')}
                              options={Array.from(
                                new Set(
                                  packageData
                                    ?.filter(i => i.os.includes('Linux'))
                                    ?.map(item => item.os),
                                ),
                              ).map(item => ({ value: item, label: item }))}
                            />
                          </Form.Item>
                        </>
                      )}

                      <Form.Item
                        label={t('连接方式')}
                        name="disposition1"
                        initialValue={t('直连')}
                        style={{ marginBottom: '20px' }}
                      >
                        <Select
                          style={{ width: '320px', height: '32px' }}
                          onSelect={e => {
                            setParams('')
                            if (e === t('代理')) {
                              setAgentVisible1(true)
                              setConnectType(2)
                            } else {
                              setAgentVisible1(false)
                              setConnectType(1)
                            }
                          }}
                        >
                          <Select.Option value={t('直连')}>{t('直连')}</Select.Option>
                          <Select.Option value={t('代理')}>{t('代理')}</Select.Option>
                        </Select>
                      </Form.Item>
                      <Form.Item>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <span style={{ display: 'inline-block', marginRight: '20px' }}>
                            {t('自动安装验证环境')}
                          </span>
                          <Form.Item name="autoInstallDependencyEnv" valuePropName="checked">
                            <BasSwitch onChange={e => setAutoInstallDependencyEnv(e)} />
                          </Form.Item>
                          <Tooltip title={t('开启后会自动安装Nginx、Tomcat等依赖环境至本地')}>
                            <IconFont
                              type="icon-icon_help"
                              style={{
                                color: '#999',
                                marginLeft: 16,
                                fontSize: 16,
                                cursor: 'pointer',
                              }}
                            />
                          </Tooltip>
                        </div>
                      </Form.Item>
                      <Form.Item>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <span
                            style={{ display: 'inline-block', marginRight: '20px', width: '112px' }}
                          >
                            {t('启用DNAT配置')}
                          </span>
                          <Form.Item
                            name="enableDnatConfig"
                            valuePropName="checked"
                            initialValue={false}
                          >
                            <BasSwitch
                              onChange={e => {
                                setEnableDnatConfig(e)
                                if (!e) {
                                  createForm.setFieldsValue({
                                    externalAddress: undefined,
                                    platformAddress: undefined,
                                    webServiceExternalPort: undefined,
                                    webServicePlatformPort: undefined,
                                    dlpHttpExternalPort: undefined,
                                    dlpHttpPlatformPort: undefined,
                                    dlpHttpsExternalPort: undefined,
                                    dlpHttpsPlatformPort: undefined,
                                    dlpGitExternalPort: undefined,
                                    dlpGitPlatformPort: undefined,
                                  })
                                }
                              }}
                            />
                          </Form.Item>
                          <Tooltip
                            title={t(
                              '若您的网络环境中,客户端无法直接访问BAS平台真实服务IP,可开启DNAT配置并填写地址映射关系,以确保客户端请求能正确转发到平台服务。',
                            )}
                          >
                            <IconFont
                              type="icon-icon_help"
                              style={{
                                color: '#999',
                                marginLeft: 16,
                                fontSize: 16,
                                cursor: 'pointer',
                              }}
                            />
                          </Tooltip>
                        </div>
                      </Form.Item>
                      {enableDnatConfig && (
                        <div className="dnat-container">
                          <div
                            className="box"
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              marginBottom: '20px',
                              gap: '16px',
                            }}
                          >
                            <div
                              style={{
                                fontWeight: 500,
                                color: '#333',
                                width: '186px',
                                flexShrink: 0,
                                lineHeight: '32px',
                              }}
                            >
                              {t('地址映射')}
                            </div>
                            <div
                              className="dnat-form-item"
                              style={{ display: 'flex', gap: '0px', flex: 1, minWidth: 0 }}
                            >
                              <Form.Item
                                label={t('外部地址')}
                                name="source_host"
                                style={{
                                  flex: 1,
                                  marginBottom: 0,
                                  minWidth: 0,
                                  marginRight: '10px',
                                }}
                                rules={[{ required: true, message: t('请填写用于映射的IP/域名') }]}
                              >
                                <Input
                                  style={{ width: '100%', height: '32px' }}
                                  placeholder={t('请填写用于映射的IP/域名')}
                                />
                              </Form.Item>
                              <Form.Item
                                label={t('平台地址')}
                                name="submit_destination_host"
                                className="destination_host"
                                style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                rules={[{ required: true, message: t('请填写平台IP/域名') }]}
                              >
                                <Input
                                  style={{ width: '100%', height: '32px' }}
                                  placeholder={t('请填写平台IP/域名')}
                                />
                              </Form.Item>
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              marginBottom: '20px',
                              gap: '16px',
                            }}
                          >
                            <div
                              style={{
                                fontWeight: 500,
                                color: '#333',
                                width: '60px',
                                flexShrink: 0,
                                lineHeight: '32px',
                              }}
                            >
                              {t('端口映射')}
                            </div>
                            <div style={{ flex: 1 }}>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  marginBottom: '20px',
                                  gap: '16px',
                                }}
                              >
                                <div
                                  style={{
                                    width: '120px',
                                    fontWeight: 500,
                                    color: '#666',
                                    fontSize: '14px',
                                    flexShrink: 0,
                                  }}
                                >
                                  {t('平台Web服务')}
                                </div>
                                <div style={{ display: 'flex', gap: '16px', flex: 1, minWidth: 0 }}>
                                  <Form.Item
                                    label={t('外部端口')}
                                    name="saas_source_port"
                                    style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                  >
                                    <InputNumber
                                      style={{ width: '100%' }}
                                      placeholder={t('请填写用于映射端口')}
                                      min={1}
                                      max={65535}
                                    />
                                  </Form.Item>
                                  <Form.Item
                                    label={t('平台端口')}
                                    name="saas_destination_port"
                                    style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                  >
                                    <InputNumber
                                      style={{ width: '100%' }}
                                      placeholder={t('请填写平台端口')}
                                      min={1}
                                      max={65535}
                                      disabled
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  marginBottom: '20px',
                                  gap: '16px',
                                }}
                              >
                                <div
                                  style={{
                                    width: '120px',
                                    fontWeight: 500,
                                    color: '#666',
                                    fontSize: '14px',
                                    flexShrink: 0,
                                  }}
                                >
                                  {t('数据防泄漏 (HTTP)')}
                                </div>
                                <div style={{ display: 'flex', gap: '16px', flex: 1, minWidth: 0 }}>
                                  <Form.Item
                                    label={t('外部端口')}
                                    name="data_protect_http_source_port"
                                    style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                  >
                                    <InputNumber
                                      style={{ width: '100%' }}
                                      placeholder={t('请填写用于映射端口')}
                                      min={1}
                                      max={65535}
                                    />
                                  </Form.Item>
                                  <Form.Item
                                    label={t('平台端口')}
                                    name="data_protect_http_destination_port"
                                    style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                  >
                                    <InputNumber
                                      style={{ width: '100%' }}
                                      placeholder={t('请填写平台端口')}
                                      min={1}
                                      max={65535}
                                      disabled
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  marginBottom: '20px',
                                  gap: '16px',
                                }}
                              >
                                <div
                                  style={{
                                    width: '120px',
                                    fontWeight: 500,
                                    color: '#666',
                                    fontSize: '14px',
                                    flexShrink: 0,
                                  }}
                                >
                                  {t('数据防泄漏 (HTTPS)')}
                                </div>
                                <div style={{ display: 'flex', gap: '16px', flex: 1, minWidth: 0 }}>
                                  <Form.Item
                                    label={t('外部端口')}
                                    name="data_protect_https_source_port"
                                    style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                  >
                                    <InputNumber
                                      style={{ width: '100%' }}
                                      placeholder={t('请填写用于映射端口')}
                                      min={1}
                                      max={65535}
                                    />
                                  </Form.Item>
                                  <Form.Item
                                    label={t('平台端口')}
                                    name="data_protect_https_destination_port"
                                    style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                  >
                                    <InputNumber
                                      style={{ width: '100%' }}
                                      placeholder={t('请填写平台端口')}
                                      min={1}
                                      max={65535}
                                      disabled
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  marginBottom: '20px',
                                  gap: '16px',
                                }}
                              >
                                <div
                                  style={{
                                    width: '120px',
                                    fontWeight: 500,
                                    color: '#666',
                                    fontSize: '14px',
                                    flexShrink: 0,
                                  }}
                                >
                                  {t('数据防泄漏 (GIT)')}
                                </div>
                                <div style={{ display: 'flex', gap: '16px', flex: 1, minWidth: 0 }}>
                                  <Form.Item
                                    label={t('外部端口')}
                                    name="data_protect_git_source_port"
                                    style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                  >
                                    <InputNumber
                                      style={{ width: '100%' }}
                                      placeholder={t('请填写用于映射端口')}
                                      min={1}
                                      max={65535}
                                    />
                                  </Form.Item>
                                  <Form.Item
                                    label={t('平台端口')}
                                    name="data_protect_git_destination_port"
                                    style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                  >
                                    <InputNumber
                                      style={{ width: '100%' }}
                                      placeholder={t('请填写平台端口')}
                                      min={1}
                                      max={65535}
                                      disabled
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {agentVisible1 && (
                        <>
                          <Form.Item
                            label={t('代理地址')}
                            name="address1"
                            style={{ marginBottom: '20px' }}
                            rules={[
                              {
                                required: true,
                                message: t('请输入代理地址'),
                              },
                              {
                                pattern:
                                  /^(?:(?:[A-Za-z0-9](?:[A-Za-z0-9\-]{0,61}[A-Za-z0-9])?\.)+(?:[A-Za-z]{2,6}\.?|[A-Za-z0-9\-]{2,}\.?)|(?:\d{1,3}\.){3}\d{1,3}):(\d{1,5})$/,
                                message: t('输入格式错误'),
                              },
                            ]}
                          >
                            <Input
                              style={{ width: '320px', height: '32px' }}
                              placeholder={t('请输入域名：端口或IP：端口')}
                            />
                          </Form.Item>
                          <Form.Item
                            label={t('代理协议')}
                            name="agreement1"
                            rules={[
                              {
                                required: true,
                                message: t('请选择代理协议'),
                              },
                            ]}
                          >
                            <Select
                              style={{ width: '320px', height: '32px' }}
                              placeholder={t('请选择代理协议')}
                            >
                              <Select.Option value="HTTPS">HTTPS</Select.Option>
                              <Select.Option value="HTTP">HTTP</Select.Option>
                              <Select.Option value="SOCKS5">SOCKS5</Select.Option>
                            </Select>
                          </Form.Item>
                          <Form.Item
                            label={t('代理用户名')}
                            name="username1"
                            style={{ marginBottom: '20px' }}
                          >
                            <Input
                              style={{ width: '320px', height: '32px' }}
                              placeholder={t('请输入代理用户名（可选）')}
                            />
                          </Form.Item>
                          <Form.Item
                            label={t('代理密码')}
                            name="password1"
                            style={{ marginBottom: '20px' }}
                          >
                            <Input.Password
                              style={{ width: '320px', height: '32px' }}
                              placeholder={t('请输入代理密码（可选）')}
                            />
                          </Form.Item>
                        </>
                      )}
                    </div>
                  </div>
                </FormItem>
                {installStyle1 === '1' && (
                  <FormItem>
                    <div className="title">
                      <SvgIcon
                        name={'download'}
                        style={{ width: '80px', height: '90px', margin: '-20px 0 -22px -25px' }}
                      />
                      <span className="formWord" style={{ margin: '-6px 0 0 -20px' }}>
                        {t(
                          '下载安装包（银河麒麟V10操作系统环境可直接使用X86架构Linux. rpm安装包安装）',
                        )}
                      </span>
                    </div>
                    <div className="content">
                      <div className="line" />
                      <div className="itemForm" style={{ margin: '30px 0' }}>
                        <DownloadKey
                          switchChange={switchChange}
                          installation={installation}
                          installData={installData}
                        />
                      </div>
                    </div>
                  </FormItem>
                )}
                <FormItem style={{ width: '100%', marginBottom: '50px' }}>
                  <div className="title">
                    <SvgIcon
                      name={'generate'}
                      style={{ width: '80px', height: '90px', margin: '-20px 0 -22px -25px' }}
                    />

                    <span className="formWord" style={{ margin: '-6px 0 0 -20px' }}>
                      {installStyle1 === '1' && t('生成参数')}
                      {installStyle1 === '2' && t('生成命令')}
                    </span>
                  </div>
                  <div className="content">
                    <div className="line" style={{ border: ' 1px solid #fff' }} />
                    <div style={{ width: '100%' }}>
                      <Button
                        type="primary"
                        style={{ margin: '20px 15px 8px 0', float: 'right' }}
                        onClick={createForm.submit}
                      >
                        {installStyle1 === '1' && t('生成参数')}
                        {installStyle1 === '2' && t('生成命令')}
                      </Button>
                      {installStyle1 === '1' &&
                        (switchChange === 'windows' ? (
                          <span
                            style={{
                              marginTop: '37px',
                              display: 'inline-block',
                              fontSize: '12px',
                              fontWeight: '400',
                              color: '#999',
                            }}
                          >
                            {t('运行安装程序后，将生成的参数填入并点击安装即可')}
                          </span>
                        ) : (
                          <span
                            style={{
                              marginTop: '37px',
                              display: 'inline-block',
                              fontSize: '12px',
                              fontWeight: '400',
                              color: '#999',
                            }}
                          >
                            {t('下载安装包后，运行安装命令即可')}
                          </span>
                        ))}
                      {installStyle1 === '2' &&
                        (switchChange === 'linux' || switchChange === 'uos' ? (
                          <span
                            style={{
                              marginTop: '37px',
                              display: 'inline-block',
                              fontSize: '12px',
                              fontWeight: '400',
                              color: '#999',
                            }}
                          >
                            {t('请以root权限运行以下命令')}
                          </span>
                        ) : (
                          <span
                            style={{
                              marginTop: '37px',
                              display: 'inline-block',
                              fontSize: '12px',
                              fontWeight: '400',
                              color: '#999',
                            }}
                          >
                            {t('请在cmd中以管理员权限运行以下命令')}
                          </span>
                        ))}
                      <div
                        style={{
                          height: '100px',
                          marginRight: '15px',
                          background: '#F8F9FB',
                          borderRadius: ' 6px',
                          clear: 'both',
                          display: 'flex',
                          gap: '7px',
                          padding: '12px',
                          wordBreak: 'break-all',
                        }}
                      >
                        <Typography.Paragraph
                          copyable={{
                            icon: [
                              <IconFont style={{ color: '#999' }} key={1} type="icon-fuzhi" />,
                            ],
                            text: params,
                          }}
                        />
                        <span>{params}</span>
                      </div>
                    </div>
                  </div>
                </FormItem>
              </>
            )}
          </Form>
        </Middle>
        <div style={{ borderRight: '1px dashed #D9D9D9' }} />
        <Right>
          <div style={{ fontSize: '16px', fontWeight: '500', color: '#333', marginBottom: '20px' }}>
            {t('下载说明')}
          </div>
          <OperateSystem switchChange={switchChange} />
          <div>
            <div>
              <span style={{ display: 'inline-block', margin: '24px 0 10px 0' }}>
                {t('安装说明')}
              </span>
              <span>：</span>
            </div>
            {switchChange === 'windows' ? (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span
                  style={{
                    display: 'inline-block',
                    color: '#666',
                    marginBottom: '10px',
                  }}
                >
                  <span
                    style={{
                      width: '8px',
                      height: '8px',
                      background: '#558492',
                      display: 'inline-block',
                      borderRadius: '4px',
                      marginRight: '6px',
                    }}
                  />
                  {t('安装客户端时需要管理员权限')}
                </span>

                <span
                  style={{
                    display: 'inline-block',
                    color: '#666',
                    marginBottom: '10px',
                  }}
                >
                  <span
                    style={{
                      width: '8px',
                      height: '8px',
                      background: '#558492',
                      display: 'inline-block',
                      borderRadius: '4px',
                      marginRight: '6px',
                    }}
                  />
                  {t('客户端启动时会占用TCP协议62678端口,请确保端口未被占用')}
                </span>
                <span style={{ display: 'inline-block', color: '#666' }}>
                  <span
                    style={{
                      width: '8px',
                      height: '8px',
                      background: '#558492',
                      display: 'inline-block',
                      borderRadius: '4px',
                      marginRight: '6px',
                    }}
                  />
                  {t('请勿在已安装的机器重复操作')}
                </span>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span
                  style={{
                    display: 'inline-block',
                    color: '#666',
                    marginBottom: '10px',
                  }}
                >
                  <span
                    style={{
                      width: '8px',
                      height: '8px',
                      background: '#558492',
                      display: 'inline-block',
                      borderRadius: '4px',
                      marginRight: '6px',
                    }}
                  />
                  {t('下载安装包后，运行安装命令即可')}
                </span>
                <span style={{ display: 'inline-block', color: '#666' }}>
                  <span
                    style={{
                      width: '8px',
                      height: '8px',
                      background: '#558492',
                      display: 'inline-block',
                      borderRadius: '4px',
                      marginRight: '6px',
                    }}
                  />
                  {t('请勿在已安装的机器重复操作')}
                </span>
              </div>
            )}
          </div>
        </Right>
        {keyVisible && (
          <Modal
            centered
            title={
              <div style={{ display: 'flex' }}>
                <span
                  style={{
                    display: 'inline-block',
                    width: '4px',
                    height: '22px',
                    background: '#4238C9',
                    borderRadius: '2px',
                    marginRight: '8px',
                  }}
                />
                <span>{t('客户端密钥')}</span>
              </div>
            }
            open={keyVisible}
            // closable={false}
            footer={null}
            onOk={() => {
              setKeyVisible(false)
            }}
            onCancel={() => {
              setKeyVisible(false)
            }}
          >
            <Warning
              style={{ width: '100%', margin: '0px 0 16px', height: 52 }}
              textStyle={{ lineHeight: '1.5' }}
              text={t(
                '提示：密钥用于客户端注册，密钥到期后将自动更新，密钥每24小时内重置次数上限为5次，请勿将密钥告知他人',
              )}
            />
            <SecretKey
              style={{
                background: '#f7f7f7',
                padding: '10px 12px 1px',
                borderRadius: 6,
              }}
            >
              <SvgIcon name={'secret-key'} width={12} height={12} />
              {t('密钥:')}
              <div style={{ display: 'flex', gap: '8px' }}>
                <Typography.Paragraph
                  copyable={{
                    icon: [<IconFont style={{ color: '#999' }} key={1} type="icon-fuzhi" />],
                    text: angentKey.token,
                  }}
                />
                <span style={{ width: '95%' }}>{angentKey.token}</span>
              </div>
            </SecretKey>
            <SecretKey>
              {t('密钥到期日：')}
              {angentKey.expire_date}
            </SecretKey>
            <SecretKey style={{ marginBottom: '0' }}>
              <Button
                block
                type={'primary'}
                loading={resetAngentKeyLoading}
                onClick={async () => {
                  try {
                    await resetAngentKey()
                    getAngentKey()
                  } catch (error) {}
                }}
              >
                {t('重新生成密钥')}
              </Button>
            </SecretKey>
          </Modal>
        )}
      </PageContain>
    </Page>
  )
}
const SecretKey = styled.div`
  line-height: 1.5;
  margin-bottom: 24px;
`
const Page = styled.div`
  background-color: #f1f3f5;
  padding: 12px;
`
const PageContain = styled.div`
  min-height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: row;
  box-shadow: 0px 4px 8px 0px rgba(95, 103, 129, 0.06);
  border-radius: 8px;
  .ant-modal-body {
    padding: 0 32px 24px 32px;
  }
`
const Left = styled.div`
  width: 12%;
  display: flex;
  gap: 80px;
  /* justify-content: center; */
  /* align-items: center; */
  flex-direction: column;
  margin-top: 150px;
  padding-left: 2.5%;
  /* margin-top: -12px; */
  .img {
    width: 100px;
    height: 100px;
    background: #e7e9f3;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
    .svg {
      width: 40px;
      height: 40px;
    }
    :hover {
      background: #e7e9f3;
    }
  }
  .img_grey {
    width: 100px;
    height: 100px;
    /* background: #e7e9f3; */
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
    .svg {
      width: 40px;
      height: 40px;
    }
    :hover {
      background: #e7e9f3;
    }
  }
`
const Middle = styled.div`
  width: 62%;
  .ant-form-item {
    margin-bottom: 0;
  }
  .dnat-form-item {
    .ant-form-item-label {
      margin-right: 10px;
    }
  }
  .ant-form-vertical .ant-form-item:has(.ant-switch) {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    .ant-form-item-row {
      display: flex !important;
      flex-direction: row !important;
      align-items: center !important;
      width: 100% !important;
      gap: 0 !important;
    }
    .ant-form-item-label {
      padding-bottom: 0 !important;
      padding-right: 4px !important;
      margin-bottom: 0 !important;
      label {
        margin-bottom: 0 !important;
      }
    }
    .ant-form-item-control {
      flex: none !important;
      margin-bottom: 0 !important;
      margin-left: 0 !important;
    }
  }
  .dnat-container {
    .ant-form-vertical .ant-form-item-label {
      padding-bottom: 0;
    }
    .destination_host {
      .ant-form-item-label {
        margin-right: 3px;
      }
    }
    .ant-form-item {
      display: flex !important;
      flex-direction: row !important;
      align-items: flex-start !important;
      margin-bottom: 0 !important;
      .ant-form-item-row {
        display: flex !important;
        flex-direction: row !important;
        align-items: flex-start !important;
        width: 100% !important;
        flex-wrap: nowrap !important;
      }
      .ant-form-item-label {
        flex-shrink: 0 !important;
        width: 40px !important;
        padding-right: 8px !important;
        padding-bottom: 0 !important;
        text-align: left !important;
        margin-bottom: 0 !important;
        vertical-align: top !important;
        // padding-top: 4px !important;
        label {
          height: 32px !important;
          line-height: 32px !important;
          white-space: nowrap !important;
          margin-bottom: 0 !important;
          display: inline-block !important;
          vertical-align: middle !important;
        }
      }
      .ant-form-item-control {
        flex: 1 !important;
        min-width: 0 !important;
        margin-bottom: 0 !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: stretch !important;
        .ant-form-item-control-input {
          min-height: 32px !important;
          display: flex !important;
          align-items: center !important;
        }
        .ant-form-item-control-input-content {
          display: flex !important;
          align-items: center !important;
        }
        .ant-form-item-explain {
          margin-top: 0 !important;
          margin-bottom: 0 !important;
          line-height: 1.5 !important;
        }
        .ant-form-item-explain-error {
          margin-top: 0 !important;
          margin-bottom: 0 !important;
          line-height: 1.5 !important;
        }
      }
    }
  }
`
const FormItem = styled.div`
  .title {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .content {
    display: flex;
    margin: -6px 0;
    .line {
      border: 1px solid #4238c9;
      margin-left: 14px;
      margin-right: 60px;
    }
    .itemForm {
      margin: 30px 0;
      /* min-height: 141px; */
      display: flex;
      flex-direction: column;
    }
  }
  .icon {
    display: inline-block;
    width: 32px;
    height: 32px;
    background: #fff;
    border-radius: 50%;
    box-shadow: 0px 4px 8px 0px rgba(95, 103, 129, 0.06);
  }
  .iconSvg {
    width: 30px;
    height: 30px;
    background-color: #e9ebef;
    border-radius: 50%;
  }
  .formWord {
    display: inline-block;
    line-height: 32px;
  }
`
const Right = styled.div`
  width: 26%;
  padding: 20px 15px;
  .ant-descriptions-bordered .ant-descriptions-item-content {
    background-color: #f7f7f7;
    border-top: 0 solid #f7f7f7;
  }
  .ant-descriptions-bordered .ant-descriptions-item-label {
    background-color: #f7f7f7;
  }
  .ant-descriptions-bordered .ant-descriptions-view {
    border: 1px solid #f7f7f7;
  }
`
